import * as ActionTypes from '../actions/actionTypes'
import objectPath from 'object-path'

export default function reduce(state = {}, action)
{
    let newState, stateLocation;
    switch(action.type)
    {
        case ActionTypes.hideTimeoutWarning:
            stateLocation = action.payload.stateLocation;
            newState = Object.assign({}, state);
            objectPath.set(newState, stateLocation, false);

            return newState;

        case ActionTypes.setInactivityTime:
        case ActionTypes.setSessionStartTime:
            stateLocation = action.payload.stateLocation;
            newState = Object.assign({}, state);
            objectPath.set(newState, stateLocation, action.payload.time);

            return newState;

        case ActionTypes.showTimeoutWarning:
            stateLocation = action.payload.stateLocation;
            newState = Object.assign({}, state);
            objectPath.set(newState, stateLocation, true);

            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/timeout-warning-overlay/src/reducers/index.js